// extracted by mini-css-extract-plugin
module.exports = {"cards":"searchResults_cards__IxBmB","pagination":"searchResults_pagination__ZYDEN","noResults":"searchResults_noResults__Z5gTJ"};